import { useParentNavAlwaysEnabled } from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import { useAbility } from 'utilities/ability'
import AccordionButton from '../Bar/AccordionButton'
import MenuItem from '../Bar/MenuItem'
import CampaignsContent from './Content'

const t = buildTranslate('nav.campaigns_menu')

type Props = {
  isLeftNav?: boolean
  onClick?: () => void
  paths: string[]
}

const Campaigns = (props: Props) => {
  const { isLeftNav = false, onClick = () => {}, paths } = props
  const ability = useAbility()
  const parentAlwaysEnabled = useParentNavAlwaysEnabled()

  const menuDisabled =
    !parentAlwaysEnabled && ability.cannot('access', 'AllCampaigns')

  const Parent = isLeftNav ? AccordionButton : MenuItem

  return (
    <Parent disabled={menuDisabled} paths={paths} buttonContents={t('button')}>
      <CampaignsContent isLeftNav={isLeftNav} onClick={onClick} />
    </Parent>
  )
}

export default Campaigns
